module.exports = __webpack_public_path__ + "img/w3_grid_black.68a0fb66.png";